import { Dropdown as AntdDropdown } from 'antd';
import React from 'react';
export const Dropdown = (props) => (React.createElement(AntdDropdown, { ...props }));
